import React from 'react';
import FaqsLayout from './faqs-layout';

export default class FaqsMutua extends React.Component<{}, {}> {
    render(){
        return(
            <FaqsLayout/>
        )
    }
}